import { render, staticRenderFns } from "./importOdidoSubscriptionsDialog.vue?vue&type=template&id=5e967998&scoped=true"
import script from "./importOdidoSubscriptionsDialog.vue?vue&type=script&lang=ts"
export * from "./importOdidoSubscriptionsDialog.vue?vue&type=script&lang=ts"
import style0 from "./importOdidoSubscriptionsDialog.vue?vue&type=style&index=0&id=5e967998&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e967998",
  null
  
)

export default component.exports